// KL - aircond not cold (problem page).
const content = {
    slug: 'aircond-not-cold',
    title: 'Aircond Not Cold in KL? Causes, Quick Checks and Fixes',
    description: (c) =>
        `Aircond not cold? The usual causes in KL homes, checks you can do, and what each fix costs - from a ${c.money(c.tables.general[0].wall)} service to a gas top up.`,
    eyebrow: 'KL · Aircond not cold',
    h1: 'Aircond Not Cold? What to Check in KL',
    lead: 'An aircond that runs all night but leaves the bedroom warm is usually dirty, sometimes low on gas, and occasionally broken. Here is how to tell which - and what it costs to fix.',
    image: 'blog/living/cool-air-from-aircon.jpg',
    imageAlt: 'Checking air temperature from an aircond that is not cold',
    facts: ['Check 5 things first', 'Most cases: dirty coil', 'Diagnosis if unsure'],
    ctaLabel: 'See fixes and prices',
    priceTitle: 'The fixes that solve most cases',
    priceIntro: 'A chemical wash fixes the most common cause - a coil clogged with damp dust. Start with a general service if the unit was cleaned recently.',
    panel: { type: 'servicing', services: ['chemicalWash', 'general'], defaultMount: 'Wall' },
    sections: [
        {
            title: 'Five quick checks',
            steps: [
                { title: 'Mode', body: 'Is the remote on Cool (snowflake), not Dry, Fan or Auto? Dry mode in particular feels weak.' },
                { title: 'Temperature setting', body: 'Set it to 24°C and give it 20 minutes. Setting 16°C doesn\'t cool faster.' },
                { title: 'Filter', body: 'Pull out the filters behind the front panel. If they\'re grey and furry, rinse them and try again.' },
                { title: 'Outdoor unit', body: 'Is its fan spinning? Is it blocked by laundry, plants or a cover? It needs space to release heat.' },
                { title: 'Room load', body: 'A 1.0hp unit in a west-facing room with the door open will struggle at 4 pm. See our HP room size guide.' },
            ],
        },
        {
            title: 'Usual causes',
            tone: 'muted',
            cards: [
                { title: 'Dirty coil or blower', body: 'Air is cold but weak. Fixed by a chemical wash.' },
                { title: 'Low gas', body: 'Air is barely cool, frost on pipes. Needs a leak check and gas top up.' },
                { title: 'Faulty capacitor', body: 'Indoor fan runs, outdoor unit silent. Small part, quick repair.' },
                { title: 'Wrong size', body: 'Unit too small for the room. Common when a 1.0hp is moved to a bigger room.' },
            ],
        },
    ],
    faqs: [
        {
            question: 'Why is my aircond running but not cold?',
            answer: 'Most often a dirty filter or coil, then low gas, then a failed capacitor in the outdoor unit. Wash the filter first - if it doesn\'t help, book a service.',
        },
        {
            question: 'How much does it cost to fix an aircond that is not cold?',
            answer: (c) => `A general service costs ${c.money(c.tables.general[0].wall)}, a chemical wash ${c.money(c.tables.chemicalWash[0].wall)}, an R32 gas top up ${c.money(c.tables.gas.R32.half)}, and a diagnosis visit ${c.money(c.tables.repairDiagnosis)}.`,
        },
        {
            question: 'Aircond tak sejuk - what should I do first?',
            answer: 'Check the mode, wash the filter and make sure the outdoor fan is running. If it still isn\'t cold, book a service. We have a full guide in Bahasa Melayu too.',
        },
    ],
    alternates: [
        { hreflang: 'en-my', path: '/my/aircond-service-kuala-lumpur/aircond-not-cold' },
        { hreflang: 'ms-my', path: '/my/aircond-service-kuala-lumpur/aircond-tak-sejuk' },
    ],
    schema: {
        name: 'Aircond Not Cold - Fix in Kuala Lumpur',
        serviceType: 'Air conditioner troubleshooting',
        offers: (c) => [
            { name: 'Chemical wash, 1 unit', price: c.tables.chemicalWash[0].wall },
            { name: 'General service, 1 unit', price: c.tables.general[0].wall },
            { name: 'Repair diagnosis visit', price: c.tables.repairDiagnosis },
        ],
    },
}

export default content
